import React from "react";

const STEPS = [
  { id: "edit", label: "Edit Invitation", shortLabel: "Edit", icon: "✎" },
  { id: "preview", label: "Preview", shortLabel: "Preview", icon: "▶" },
  { id: "details", label: "Finalize Details", shortLabel: "Details", icon: "◆" },
  { id: "theme", label: "Choose Theme", shortLabel: "Theme", icon: "◐" },
  { id: "guests", label: "Manage Guests", shortLabel: "Guests", icon: "●" },
];

export function WorkflowSteps({ currentStep }) {
  const currentIndex = STEPS.findIndex((step) => step.id === currentStep);
  const currentStepDetails = STEPS[currentIndex] || STEPS[0];
  const progressPercent =
    currentIndex > -1 && STEPS.length > 1 ? (currentIndex / (STEPS.length - 1)) * 100 : 0;

  return (
    <div className="rounded-[18px] border border-[#ead9e7] bg-white/88 px-3 py-2 shadow-[0_10px_28px_rgba(125,70,105,0.06)] backdrop-blur md:rounded-[26px] md:px-5 md:py-4">
      <div className="flex flex-col gap-2 md:gap-3 lg:flex-row lg:items-center lg:justify-between">
        <div className="hidden md:block">
          <p className="text-[10px] font-bold uppercase tracking-[0.24em] text-[#b07c98]">
            Setup Progress
          </p>
          <p className="mt-1 text-sm text-[#7e6777]">
            Complete the invitation flow step by step.
          </p>
        </div>

        <div className="flex items-center justify-between gap-3 md:hidden">
          <div>
            <p className="text-[9px] font-bold uppercase tracking-[0.22em] text-[#b07c98]">
              Step {currentIndex + 1}/{STEPS.length}
            </p>
            <p className="mt-0.5 text-sm font-extrabold text-[#42283a]">
              {currentStepDetails.label}
            </p>
          </div>
          <span className="rounded-full bg-[#fff1f8] px-2.5 py-1 text-[10px] font-bold uppercase tracking-[0.16em] text-[#a52b69]">
            {Math.round(progressPercent)}%
          </span>
        </div>

        <div className="relative flex items-center justify-between gap-1.5 md:hidden">
          <span className="absolute left-4 right-4 top-1/2 h-0.5 -translate-y-1/2 rounded-full bg-[#f1dfeb]" />
          <span
            className="absolute left-4 top-1/2 h-0.5 -translate-y-1/2 rounded-full bg-gradient-to-r from-[#ff0099] to-[#ff7a45] transition-all"
            style={{ width: `calc((100% - 2rem) * ${progressPercent / 100})` }}
          />
          {STEPS.map((step, index) => {
            const isCurrent = step.id === currentStep;
            const isCompleted = currentIndex > -1 && index < currentIndex;

            return (
              <div
                key={step.id}
                className="relative z-10 flex flex-col items-center gap-1"
                title={step.label}
                aria-label={`${step.label}${isCurrent ? ", current step" : ""}`}
              >
                <span
                  className={`flex h-8 w-8 items-center justify-center rounded-full border text-xs font-black shadow-sm ${
                    isCurrent
                      ? "border-[#ff0099] bg-[#ff0099] text-white shadow-[#ff0099]/20"
                      : isCompleted
                        ? "border-[#ffd2e9] bg-white text-[#a52b69]"
                        : "border-[#ead9e7] bg-white text-[#b497a8]"
                  }`}
                >
                  {isCompleted ? "✓" : step.icon}
                </span>
                <span
                  className={`text-[9px] font-bold uppercase tracking-[0.08em] ${
                    isCurrent ? "text-[#a52b69]" : "text-[#b497a8]"
                  }`}
                >
                  {step.shortLabel}
                </span>
              </div>
            );
          })}
        </div>

        <div className="hidden flex-wrap items-center gap-2 md:flex">
          {STEPS.map((step, index) => {
            const isCurrent = step.id === currentStep;
            const isCompleted = currentIndex > -1 && index < currentIndex;

            return (
              <React.Fragment key={step.id}>
                <div
                  className={`flex items-center gap-2 rounded-full px-3 py-2 text-xs font-bold uppercase tracking-[0.18em] ${
                    isCurrent
                      ? "bg-[#ff0099] text-white shadow-lg shadow-[#ff0099]/20"
                      : isCompleted
                        ? "bg-[#fff1f8] text-[#a52b69]"
                        : "bg-[#f7f1f5] text-[#b497a8]"
                  }`}
                >
                  <span
                    className={`flex h-5 w-5 items-center justify-center rounded-full text-[10px] ${
                      isCurrent
                        ? "bg-white/20 text-white"
                        : isCompleted
                          ? "bg-white text-[#a52b69]"
                          : "bg-white text-[#b497a8]"
                    }`}
                  >
                    {index + 1}
                  </span>
                  <span>{step.label}</span>
                </div>
                {index < STEPS.length - 1 ? (
                  <span className="hidden text-[#d0bec9] md:inline">/</span>
                ) : null}
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </div>
  );
}
